import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/getFiltrarAlimentacion`, method: 'POST', body: values, token: token})
}
